import {api} from '../resources'
import Vue from 'vue'
import {i18n} from "@/i18n"

export default {
    namespaced: true,
    state: {
        expenses: {
            data: [],
            dirty: true
        },
        expense_groups: {
            data: [],
            dirty: true
        },
    },
    getters: {
        expenses: (state) => state.expenses.data,
        expenses_by_groups: (state) => {
            let g = [...state.expense_groups.data].sort((a, b) => a.order - b.order),
                e = [...state.expenses.data].sort((a, b) => a.order - b.order);
            return g.map(group => ({
                ...group,
                childs: e.filter(expense => expense.group_id === group.id).sort((a, b) => a.order - b.order)
            }));
        },
        expense_groups: (state) => [...state.expense_groups.data],
        defaultExpense: (state) => state.expenses.data.find(expense => expense.is_default) || null
    },
    actions: {
        async getExpenses({commit, rootState}) {
            try {
                commit('setExpensesDirty');
                const space_id = rootState.space.current_space.data.id;
                const res = await api.expenses.get({space_id})
                if (res.body.success) {
                    commit('setExpenses', res.body.data.rows);
                }
            } catch (e) {
                console.log(e)
            }
        },
        createExpense({commit}, data) {
            return api.expenses.save(data);
        },
        updateExpense({commit}, data) {
            return api.expenses.update({id: data.id}, {...data});
        },
        archiveExpense({commit}, id) {
            return api.expenses.delete({id: id});
        },
        updateExpensesOrder({commit, dispatch, rootState}, {list, group_id}) {
            const space_id = rootState.space.current_space.data.id;
            let order = {};
            list.forEach((item, o) => {
                commit('updateExpenseOrder', {...item, order: o, group_id: group_id});
                order[item.id] = o;
                //check if expense changed group
                if (group_id !== item.group_id) {
                    dispatch('updateExpense', {...item, group_id: group_id});
                }
            });
            api.expensesUpdateOrder.save({space_id, order});
        },

        //expense-groups
        createExpenseGroup({commit}, data) {
            return api.expense_groups.save(data);
        },
        async getExpenseGroups({commit, rootState}) {
            try {
                commit('setExpensesGroupsDirty');
                const space_id = rootState.space.current_space.data.id;
                const res = await api.expense_groups.get({space_id})
                if (res.body.success) {
                    commit('initGroups', res.body.data.rows);
                }
            } catch (e) {
                console.log(e)
            }
        },
        updateExpenseGroup({commit}, data) {
            return api.expense_groups.update({id: data.id}, {title: data.title});
        },
        updateExpenseGroupOrder({commit}, data) {
            return api.expense_groups.update({id: data.id}, {order: data.order});
        },
        removeExpenseGroup({commit}, id) {
            return api.expense_groups.remove(id);
        },
        setExpenseGroups({commit}, data) {
            commit('setGroups', data);
        },
        saveDefaultExpenseCategory({commit}, id) {
            return api.expenses.update({id}, {is_default: true})
        },
        updateExpensesGroupsOrder({commit, rootState}, list) {
            const space_id = rootState.space.current_space.data.id
            let order = {};
            list.forEach((item, o) => {
                if (!!item.id) {
                    commit('updateExpenseGroupOrder', item);
                    order[item.id] = o;
                }
            })
            api.expenseGroupsUpdateOrder.save({space_id, order})
        },
    },
    mutations: {
        setExpenses(state, data) {
            let arr = data;
            arr.sort((a, b) => a.order - b.order);
            state.expenses.data = arr;
            state.expenses.dirty = false;
        },
        setExpensesDirty(state) {
            state.expenses.dirty = true;
        },
        setExpensesGroupsDirty(state) {
            state.expense_groups.dirty = true;
        },
        initGroups(state, data) {
            let first = {
                    id: null,
                    title: i18n.locale === 'en' ? 'Without group' : 'Без группы',
                    order: 999
                },
                arr = [first, ...data];

            arr.sort((a, b) => a.order - b.order);
            state.expense_groups.data = arr;
            state.expense_groups.dirty = false;
        },
        setDefaultExpenseCategory(state, data) {
            let {id} = data;
            const defaultExpenseIndex = state.expenses.data.findIndex(expense => expense.id === id);
            const prevDefaultExpenseIndex = state.expenses.data.findIndex(expense => expense.is_default === true);
            state.expenses.data[prevDefaultExpenseIndex].is_default = false;
            state.expenses.data[defaultExpenseIndex].is_default = true;
        },
        updateExpenseOrder(state, data) {
            let expenseIndex = state.expenses.data.findIndex(expense => expense.id === data.id);
            Vue.set(state.expenses.data, expenseIndex, data);
        },
        updateExpenseGroupOrder(state, data) {
            let groupIndex = state.expense_groups.data.findIndex(group => group.id === data.id);
            Vue.set(state.expense_groups.data, groupIndex, data);
        },
        clearExpenses(state) {
            state.expenses.data = [];
            state.expense_groups.data = [];
            state.expenses.dirty = true;
            state.expense_groups.dirty = true;
        },
    }
}
